<ng-container>
  <ng-template [ngTemplateOutlet]="comment"></ng-template>
</ng-container>
<ng-template #comment>
  <kt-loader [showLoader]="loading()">
    <div class="min-height" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="100"
      [scrollWindow]="false" (scrolled)="onScroll()">
      <ng-container *ngIf="handoverListData && handoverListData.length">
        <ng-container *ngFor="let handoverNoteData of handoverListData">
          <div class="kt-portlet kt-portlet--bordered kt-mb-20">
            <div class="kt-portlet__body kt-portlet__body--fit">
              <div class="kt-widget kt-widget--project-1">
                <!-- header start -->
                <div class="kt-widget__head d-flex p-3">
                  <div class="d-flex align-items-center">
                    <div class="kt-user-card-v2">
                      <div *ngIf="handoverNoteData?.user_business_created_by?.user_business_profile_image_url"
                        class="kt-media kt-media--circle">
                        <img style="width: 55px; height: 55px !important;"
                          src="{{handoverNoteData?.user_business_created_by?.user_business_profile_image_url}}"
                          alt="photo">
                      </div>
                      <div style="width: 55px; height: 55px !important;"
                        *ngIf="!handoverNoteData?.user_business_created_by?.user_business_profile_image_url"
                        class="kt-badge kt-badge--xl kt-badge--rounded kt-badge--bold profileImage">
                        {{(handoverNoteData?.user_business_created_by?.user_business_first_name + '
                        ' +
                        handoverNoteData?.user_business_created_by?.user_business_last_name ) |
                        firstLetter}}
                      </div>
                      <div class="kt-user-card-v2__details  ms-2">
                        <!-- <p> </p> -->
                        <div class="kt-user-card-v2__name">
                          {{handoverNoteData?.user_business_created_by?.user_business_first_name + ' ' + handoverNoteData?.user_business_created_by?.user_business_last_name }}
                        </div>
                        <span class="kt-user-card-v2__desc">
                          <kt-role-badge [role_name]="handoverNoteData?.user_business_created_by?.user_role"
                          [associate]="handoverNoteData?.user_business_created_by?.user_role_associate">
                        </kt-role-badge>
                        </span>
                        <span class="kt-user-card-v2__desc d-block text-truncate" *ngIf="handoverNoteData?.hand_over_note_is_edited">
                          <small>Edited</small>
                        </span>
                      </div>
                    </div>

                    <div class="kt-user-card-v2 px-3 mx-3 border-right border-left">
                      <div class="kt-user-card-v2__pic">
                        <svg-icon class="svg_icon30x30 d-inline me-1" src="assets/media/iq-svg/without_circle/icon_set_3/cla_icon.svg"></svg-icon>
                      </div>
                      <div class="kt-user-card-v2__details text-truncate">
                        <span class="kt-user-card-v2__desc d-block text-truncate"><b>{{masterBusinessLabel.Client}}: </b>
                          {{ handoverNoteData?.hand_over_note_fk_client_name || ''}}</span>
                        <span class="kt-user-card-v2__desc d-block text-truncate"><b>{{masterBusinessLabel.Location}}: </b>
                          {{ handoverNoteData?.hand_over_note_fk_location_name || ''}}</span>
                        <span class="kt-user-card-v2__desc d-block text-truncate"><b> {{masterBusinessLabel.Area}}:
                          </b>{{ handoverNoteData?.hand_over_note_area && !handoverNoteData?.hand_over_note_area.length
                          ? 'All Areas' : handoverNoteData?.hand_over_note_area[0]?.hand_over_note_fk_area_name
                          }}</span>
                      </div>
                    </div>

                    <div class="kt-user-card-v2">
                      <div class="kt-user-card-v2__pic">
                        <svg-icon class="svg_icon30x30 d-inline me-1" src="assets/media/iq-svg/without_circle/icon_set_2/timesheet_time.svg"></svg-icon>
                      </div>
                      <div class="kt-user-card-v2__details text-truncate">
                        <span class="kt-user-card-v2__desc d-block text-truncate"><b>Created Date: </b>
                          {{((handoverNoteData?.hand_over_note_modified_at) ||
                          handoverNoteData?.hand_over_note_created_at) | TimezoneDate }}</span>
                        <span class="kt-user-card-v2__desc d-block text-truncate"><b> Expiry Date:
                          </b>{{ handoverNoteData?.hand_over_note_expired_at | TimezoneDate }}</span>
                      </div>
                    </div>

                  </div>

                  <div class="kt-widget__toolbar">
                    <ng-container *ngIf="activeTab === handoverNotesTypes.Active">
                      <ng-container
                        *ngxPermissionsOnly="PermissionV2.HANDOVER_NOTES_ACKNOWLEDGE_ACCESS">
                        <button
                          *ngIf="((this.userInfo && this.userInfo.user_id === handoverNoteData.hand_over_note_created_by ) || (loginUserProfile === roleRef.System_Administrator))"
                          (click)="acknowledgedList(handoverNoteData)" class="btn btn-sm kt-link me-2">
                          {{handoverNoteData.hand_over_note_trg_acknowledge_count || '0'}} Acknowledged
                        </button>
                      </ng-container>
                    </ng-container>

                    <ng-container *ngIf="activeTab === handoverNotesTypes.Active">
                      <ng-container *ngxPermissionsOnly="PermissionV2.HANDOVER_NOTES_ACKNOWLEDGE_MANAGE">
                        <!-- *ngIf="this.userInfo && this.userInfo.user_id !== handoverNoteData.hand_over_note_created_by" -->
                        <!-- <button type="button" class="btn btn-sm btn-brand me-2"
                          *ngIf="!this.checkForAcknowledge(handoverNoteData)"
                          (click)="acknowledgeConfirmation(handoverNoteData)">{{
                          this.checkForAcknowledge(handoverNoteData) ? 'Acknowledged' : 'Acknowledge'}}</button> -->
                          <button type="button" [ngClass]="this.checkForAcknowledge(handoverNoteData) ? 'default-cursor btn btn-sm btn-brand me-1 ' : 'btn btn-sm btn-brand me-1'"
                          [disabled]="this.checkForAcknowledge(handoverNoteData)"
                          (click)="acknowledgeConfirmation(handoverNoteData)">{{
                          this.checkForAcknowledge(handoverNoteData) ? 'Acknowledged' : 'Acknowledge'}}</button>
                        </ng-container>
                        <ng-container *ngxPermissionsOnly="PermissionV2.HANDOVER_NOTES_MANAGE">
                        <button type="button" class="btn btn-sm btn-success me-1"
                        [disabled]="handoverNoteData?.hand_over_note_is_done"
                          (click)="completedConfirmation(handoverNoteData)">{{ handoverNoteData?.hand_over_note_is_done ? 'Completed' : 'Complete' }}
                        </button>
                      </ng-container>

                    </ng-container>

                    <ng-container *ngIf="activeTab === handoverNotesTypes.Active">
                      <ng-container *ngxPermissionsOnly="PermissionV2.HANDOVER_NOTES_MANAGE">
                        <button (click)="editNoteClickHandler(handoverNoteData)"
                          *ngIf="this.userInfo && this.userInfo.user_id === handoverNoteData.hand_over_note_created_by"
                          type="button" class="btn btn-sm btn-clean btn-icon btn-icon-sm brand-config-color-hover">
                          <svg-icon src="assets/media/iq-svg/without_circle/icon_set_3/edit.svg"></svg-icon>
                        </button>
                      </ng-container>
                      <ng-container *ngxPermissionsOnly="PermissionV2.HANDOVER_NOTES_MANAGE">
                        <button (click)="deleteNoteConfirmation(handoverNoteData)"
                          *ngIf="this.userInfo && this.userInfo.user_id === handoverNoteData.hand_over_note_created_by || (loginUserProfile === roleRef.System_Administrator)"
                          type="button" class="btn btn-sm btn-clean btn-icon btn-icon-sm brand-config-color-hover">
                          <svg-icon src="assets/media/iq-svg/without_circle/icon_set_3/delete.svg"></svg-icon>
                        </button>
                      </ng-container>
                    </ng-container>

                    <ng-container *ngIf="activeTab === handoverNotesTypes.Completed">
                      <div class="me-2 mt-2" *ngIf="handoverNoteData.hand_over_note_is_done">
                        <span class> Completed By: </span>
                        <span> {{handoverNoteData?.user_business?.user_business_first_name + ' '
                          + handoverNoteData?.user_business?.user_business_last_name }}</span>
                      </div>
                      <ng-container *ngIf="handoverNoteData.hand_over_note_is_done">
                        <span class="btn btn-sm btn-bold btn-label-success">Completed</span>
                      </ng-container>
                      <ng-container *ngIf="!handoverNoteData.hand_over_note_is_done">
                        <span class="btn btn-sm btn-bold btn-label-danger">Expired</span>
                      </ng-container>
                    </ng-container>

                    <!-- <ng-container *ngIf="activeTab === handoverNotesTypes.Completed">
                      <ng-container *ngIf="handoverNoteData.hand_over_note_is_done">
                        <span class="btn btn-sm btn-bold btn-label-success">Completed</span>
                      </ng-container>
                      <ng-container *ngIf="!handoverNoteData.hand_over_note_is_done">
                        <span class="btn btn-sm btn-bold btn-label-danger">Expired</span>
                      </ng-container>
                    </ng-container> -->
                  </div>
                </div>

                <!-- header end -->
                <div class="kt-widget__body p-3">
                  <!-- Text section start -->
                  <span class="kt-widget__text ql-editor-preview"
                    [innerHTML]="handoverNoteData?.hand_over_note_text | safe: 'html'">
                  </span>
                  <!-- Text section end -->

                  <!-- media section start -->
                  <a *ngIf="handoverNoteData.hand_over_note_upload_1" href="javascript:void(0)"
                    class="comment-media  mr-10" (click)="fileViewerHandler(handoverNoteData)"
                    style="margin-right: 2rem;">
                    <img style="object-fit: contain;"
                      *ngIf="handoverNoteData.hand_over_note_upload_1_extension?.toLowerCase()?.includes('image')"
                      src="{{handoverNoteData.hand_over_note_upload_1}}" alt="image" class="mb-4" />
                    <img style="object-fit: contain;"
                      *ngIf="handoverNoteData.hand_over_note_upload_1_extension?.toLowerCase()?.includes('video')"
                      src="../../../../../assets/media/bg/video.jpg" alt="video" class="mb-4" />
                    <img style="object-fit: contain;"
                      *ngIf="handoverNoteData.hand_over_note_upload_1_extension?.toLowerCase()?.includes('pdf')"
                      src="../../../../../assets/media/bg/pdf.png" alt="pdf" class="mb-4" />
                    <img style="object-fit: contain;"
                      *ngIf="handoverNoteData.hand_over_note_upload_1_extension?.toLowerCase()?.includes('audio')"
                      src="../../../../../assets/media/bg/audio.png" alt="audio" class="mb-4" />
                  </a>

                  <kt-handover-notes-comment-section [activeTab]="activeTab" [handoverNoteData]="handoverNoteData">
                  </kt-handover-notes-comment-section>

                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <div class="nodata-found margin-top-150"
        *ngIf="(!handoverListData.length && (activeTab === handoverNotesTypes.Active)) && !loading()">
        <div class="nodata-found__icon fw-bold mt-10">
          <ng-lottie height="100%" width="100%"
            [options]="{ path: '../../../../../../assets/media/animation/no_active_handover_notes.json', loop: false, autoplay: true}">
          </ng-lottie>
          <div class="nodata-found__label">No Active Notes Found</div>
        </div>
      </div>
      <div class="nodata-found margin-top-150"
        *ngIf="(!handoverListData.length && (activeTab === handoverNotesTypes.Completed)) && !loading()">
        <div class="nodata-found__icon fw-bold mt-10">
          <ng-lottie height="100%" width="100%"
            [options]="{ path: '../../../../../../assets/media/animation/no_complete_handover_notes.json', loop: false, autoplay: true}">
          </ng-lottie>
          <div class="nodata-found__label">No Completed / Expired Notes Found</div>
        </div>
      </div>
    </div>

  </kt-loader>
</ng-template>
